

<template>
  <div>
    <div class="fullview">
      <div class="container-fluid">
        <div class="row m-0 p-0 align-items-center">
            <div class="col" style="white-space: break-spaces;">
                <p class="text-center acry-text-title" v-if="this.messages.length == 0">{{ this.message }}</p>
            </div>
        </div>
        <div class="row">
            <div class="col justify-content-center pt-4">
              <button class="acry-btn-primary-normal btn-size" @click="okAction">OK</button>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AlertDialog",
  components: {},
  data() {
    return {
      messages : [],
      message: this.$store.state.alertMessage,
    };
  },
  created(){
    if(this.$store.state.alertMessage.indexOf("@@@n") !== -1){
      this.messages = this.$store.state.alertMessage.split("@@@n");
    }
  },
  methods:{
      async okAction(){
        if( this.$store.state.alertCallback ){
          this.$store.state.alertCallback();
        }
        this.$store.commit("hideMessage");
      },
  }
};
</script>

<style scoped>
.fullview {
  width: 100%;
  height: 100%;
  background: #000000aa;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 50000;

  display: flex;
  align-items: center;
  justify-content: center;
}
.container-fluid {
  /* margin-right: auto;
  margin-left: auto;
  max-width: 300px;
  min-width: 300px;
  max-height: 200px;
  min-height: 200px; */
  width:559px;
  /* height:200px; */

  z-index: 10001;
  padding: 40px;
  background-color: #FEFEFE;
  border-radius: 8px;
}
.btn-size{
  width: 240px;
  height: 56px;
}
</style>
